// extracted by mini-css-extract-plugin
export default {"container":"financialHoardItems_container__KU5jz","title":"financialHoardItems_title__P8Pqw"};